/* import ScHeader from '../components/scHeader.vue' */
const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import('../views/Inicio.vue'),
        meta: { requiresAuth: true },

    },{
        path: '/cerrarFarmacia',
        name: 'cerrarFarmacia',
        props: true,
        meta: { requiresAuth: true },
        component: () => import('../views/cerrarFarmacia.vue')
    },/* {
        path: '/scHeader',
        name: 'scHeader',
        component: () => import('../components/scHeader.vue'),
        meta: { requiresAuth: true },

    },*//* {
        path: '/scHeader',
        name: 'scHeader',
        component: ScHeader,
        meta: { requiresAuth: true }
    }, */
]

export default routes